import { Reducer } from 'redux'
import { ClinicState, ClinicActionTypes } from './type'

const initialState: ClinicState = {
    selectCity: '',
    selectClinic: {},
    point:{}
}

const reducer: Reducer<ClinicState> = (state = initialState, action) => {
  switch (action.type) {
    case ClinicActionTypes.SELECT_CITY: {
      const { data } = action;
      return {
        ...state,
        selectCity: data
      }
    }
    case ClinicActionTypes.SELECT_CLINIC: {
        const { data } = action;
        return {
          ...state,
          selectClinic: data
        }
    }
      case ClinicActionTypes.SET_POINT: {
        const { data } = action;
        return {
          ...state,
          point: data
        }
    }
    default: {
      return state
    }
  }
}

export { reducer as ClinicReducer };